import { render, staticRenderFns } from "./Pablo.vue?vue&type=template&id=2dc68d1c&scoped=true&"
import script from "./Pablo.vue?vue&type=script&lang=js&"
export * from "./Pablo.vue?vue&type=script&lang=js&"
import style0 from "./Pablo.vue?vue&type=style&index=0&id=2dc68d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc68d1c",
  null
  
)

export default component.exports